// Activity keys that represent system-generated change events.
// These activities cannot be pinned to the timeline.
const CHANGE_ACTIVITY_KEYS = [
  "lead.campaign_subscription",
  "lead.campaign_subscription_delete",
  "lead.campaign_subscription.paused_due_to_text_reply",
  "lead.campaign_subscription.paused_due_to_email_reply",
  "lead.create_task",
  "lead.destroy_task",
  "lead.update_task",
  "lead.merge",
  "lead.reassign",
  "lead.release_phone_number",
  "lead.retention",
  "lead.status",
  "lead.bucket",
  "lead.update",
  "lead.owner_assigned",
  "lead.owner_changed",
  "lead.owner_removed",
  "lead.referrer_changed",
  "lead.create_resume",
  "lead.update_resume",
  "lead.delete_resume",
  "lead.create_document",
  "lead.update_document",
  "lead.delete_document",
  "lead.job_match",
  "lead.delete_job",
  "lead.candidate_applied",
  "lead.candidate_added",
  "lead.candidate_moved",
  "lead.candidate_removed",
];

export default CHANGE_ACTIVITY_KEYS;
